import React from 'react';
import { MonthProps } from '../types/Calendar.types';

export const Month: React.FC<MonthProps> = ({
  monthIndex,
  monthName,
  isSelected,
  isDisabled,
  onClick,
  className = '',
}) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (!isDisabled) {
      onClick(monthIndex);
    }
  };

  const getMonthClassName = () => {
    let baseClasses =
      'ui-w-[74px] ui-h-[48px] ui-flex ui-items-center ui-font-body-xs-semibold ui-justify-center ui-text-body-xs-medium ui-rounded ui-cursor-pointer ui-transition-colors';

    if (isDisabled) {
      baseClasses += ' ui-text-disabled ui-cursor-not-allowed';
    } else if (isSelected) {
      baseClasses += ' ui-bg-fill-brand ui-text-on-color';
    } else {
      baseClasses += ' hover:ui-bg-surface-brand hover:ui-text-brand';
    }

    return `${baseClasses} ${className}`;
  };

  return (
    <div
      className={getMonthClassName()}
      onClick={handleClick}
      role="button"
      tabIndex={isDisabled ? -1 : 0}
      aria-label={monthName}
      aria-selected={isSelected}
      aria-disabled={isDisabled}
    >
      {monthName.slice(0, 3).charAt(0).toUpperCase() + monthName.slice(1, 3)}
    </div>
  );
};
